import axios from 'axios';
import { toast } from 'react-toastify';

const hostedLegacyBase = 'https://servers.thakurgaonexpress.com/rupkotha';
const localApiBase = process.env.REACT_APP_LEGACY_API_BASE_URL || '/rupkotha';
let lastFailureNotice = 0;

function rewriteLegacyUrl(value) {
  if (typeof value !== 'string') return value;
  return value.startsWith(hostedLegacyBase)
    ? `${localApiBase}${value.slice(hostedLegacyBase.length)}`
    : value;
}

function reportRequestFailure(error, requestUrl) {
  const now = Date.now();
  if (now - lastFailureNotice > 4000) {
    lastFailureNotice = now;
    const isNetworkFailure = error?.message === 'Failed to fetch' || error?.code === 'ERR_NETWORK' || !error?.response;
    toast.error(isNetworkFailure
      ? 'Cannot reach the local POS server. Confirm the server is running, then try again.'
      : error?.response?.data?.message || 'The POS request could not be completed. Please try again.');
  }
  console.error('POS API request failed:', { requestUrl, message: error?.message, status: error?.response?.status });
}

function rewriteFetchInput(input) {
  if (typeof input === 'string') return rewriteLegacyUrl(input);
  if (input instanceof Request) {
    const rewrittenUrl = rewriteLegacyUrl(input.url);
    return rewrittenUrl === input.url ? input : new Request(rewrittenUrl, input);
  }
  return input;
}

if (typeof window !== 'undefined') {
  const browserFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const requestUrl = rewriteFetchInput(input);
    const token = window.localStorage.getItem('posSaasSession');
    try {
      return await browserFetch(requestUrl, {
        ...init,
        headers: { ...(init?.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
    } catch (error) {
      reportRequestFailure(error, typeof requestUrl === 'string' ? requestUrl : requestUrl?.url);
      throw error;
    }
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message === 'Failed to fetch' || event.reason?.code === 'ERR_NETWORK') {
      reportRequestFailure(event.reason);
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

axios.interceptors.request.use((config) => ({
  ...config,
  url: rewriteLegacyUrl(config.url),
  headers: { ...(config.headers || {}), ...(localStorage.getItem('posSaasSession') ? { Authorization: `Bearer ${localStorage.getItem('posSaasSession')}` } : {}) },
}));

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    reportRequestFailure(error, error?.config?.url);
    return Promise.reject(error);
  },
);

export { localApiBase, rewriteLegacyUrl };
